{
  "de": {
    "modelPicker": {
      "hangarTitle": "Schiffe zum Hangar hinzufügen",
      "compareTitle": "Schiffe zum Vergleichen auswählen",
      "cargoGridsTitle": "Schiffe für das Frachtraster auswählen",
      "tradeRoutesTitle": "Schiff für die Handelsrouten wählen",
      "wishlistTitle": "Schiffe zur Wunschliste hinzufügen",
      "labels": {
        "search": "Nach Name oder Hersteller suchen",
        "hangarOnly": "Nur meine Schiffe",
        "containerFit": "Zu transportierende Ladung",
        "results": "%{count} Schiffe",
        "selected": "%{count} ausgewählt"
      },
      "actions": {
        "resetFilters": "Filter zurücksetzen",
        "clearSelection": "Auswahl aufheben",
        "increase": "Weitere %{name} hinzufügen",
        "decrease": "Eine %{name} entfernen"
      },
      "badges": {
        "inHangar": "Im Hangar",
        "onWishlist": "Auf der Wunschliste",
        "comparing": "Im Vergleich",
        "onCargoGrid": "Im Raster"
      }
    }
  }
}
